export default __webpack_public_path__ + "static/media/Fall_02.02b9258e.png";